export const PRIVACY_CONSENT_TYPE = 'PRIVACY';
export const TOS_CONSENT_TYPE = 'TOS';
export const SENSITIVE_DATA_CONSENT_TYPE = 'PID_HEALTH';

export const AGE_CONSENT_TYPE = 'AGE';
export const AGE_CONSENT_FULL_AGE_LIMIT = 13;
export const AGE_CONSENT_META_DATA_BIRTHDAY = 'BIRTHDAY';
export const AGE_CONSENT_META_DATA_PARENTAL = 'PARENTAL';


// WEBPACK FOOTER //
// ./src/common.js